import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./locales/en.json";
import ja from "./locales/ja.json";
import store from "./store";
import moment from "moment";
import "moment/locale/ja"; // Need to add Japanese locale for moment

Vue.use(require("vue-moment"), { moment });
Vue.use(VueI18n);

const dateTimeFormats = {
  en: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    },
  },
  ja: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    },
  },
};

const numberFormats = {
  en: {
    currency: {
      style: "currency",
      currency: "USD",
    },
  },
  ja: {
    currency: {
      style: "currency",
      currency: "JPY",
      currencyDisplay: "symbol",
    },
  },
};

const availableLocales = ["en", "ja"];
let selectedLocale =  ( localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).locale : store.getters.locale ) || navigator.language || "en";

if (!availableLocales.includes(selectedLocale.trim())) {
  selectedLocale = "en";
}

// Create VueI18n instance with translations
const i18n = new VueI18n({
  numberFormats,
  dateTimeFormats,
  locale: selectedLocale,
  fallbackLocale: "en",
  messages: {
    en,
    ja,
  },
  preserveDirectiveContent: true,
});

// Update Moment.js locale
moment.locale(selectedLocale);
export default i18n;
